// The app no longer ships a caching service worker. This removes any service
// worker a returning user still has registered and clears its caches on every
// load (a cheap no-op once they're clean). Combined with the self-destroying
// public/service-worker.js, every user is migrated off the old SW on their next
// visit.
export function unregister() {
  if (!("serviceWorker" in navigator)) return;

  navigator.serviceWorker
    .getRegistrations()
    .then((regs) => Promise.all(regs.map((r) => r.unregister())))
    .catch(() => {});

  if (window.caches) {
    caches
      .keys()
      .then((keys) => Promise.all(keys.map((k) => caches.delete(k))))
      .catch(() => {});
  }
}
